export function getRouteParam<T>(param: T | T[]) {
  return Array.isArray(param) ? param[0] : param;
}
